/*
 * Copyright (c) 2022. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {Resource} from "../../api/resource";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {ManagerCachingStrategy} from "../../basic-entity-back/basic-entity-interface/mapping-external";

@BasicEntity({
    name: 'Tipo de envío',
    endpoint: 'tipo_envios',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'nombre',
    type: 'TipoEnvio',
    managerCaching: ManagerCachingStrategy.Lazy
})
export class TipoEnvio extends Resource {

    @BasicProperty({
        name: 'ID',
        isId: true,
        type: PropertyType.Integer()
    })
    private _id;

    @BasicProperty({
        name: 'Nombre',
        type: PropertyType.String(),
    })
    private _nombre;

    @BasicProperty({
        name: 'Clase tipo de envío',
        type: PropertyType.String(),
    })
    private _claseTipoEnvio;

    @BasicProperty({
        name: 'Coste',
        type: PropertyType.Financial(),
    })
    private _coste = 0.0;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get nombre() {
        return this._nombre;
    }

    set nombre(value) {
        this._nombre = value;
    }

    get claseTipoEnvio() {
        return this._claseTipoEnvio;
    }

    set claseTipoEnvio(value) {
        this._claseTipoEnvio = value;
    }

    get coste() {
        return this._coste;
    }

    set coste(value) {
        this._coste = value;
    }
}
